import React from 'react';
import Icon from '../../../../components/AppIcon';

const ReportsTab = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Financial Reports</h3>
          <p className="text-gray-600">Generate and view financial reports</p>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
        <div className="text-center">
          <Icon name="BarChart3" size={64} className="mx-auto text-gray-400 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Financial Reports Coming Soon</h3>
          <p className="text-gray-600 max-w-md mx-auto">
            Financial reporting functionality is currently under development. This will include Balance Sheet, 
            Profit & Loss, Cash Flow, Trial Balance, and other important financial reports.
          </p>
          <div className="mt-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto">
              <div className="p-3 border border-gray-200 rounded-lg">
                <Icon name="FileBarChart" size={24} className="mx-auto text-gray-400 mb-2" />
                <div className="text-sm font-medium text-gray-600">Balance Sheet</div>
              </div>
              <div className="p-3 border border-gray-200 rounded-lg">
                <Icon name="TrendingUp" size={24} className="mx-auto text-gray-400 mb-2" />
                <div className="text-sm font-medium text-gray-600">P&L Statement</div>
              </div>
              <div className="p-3 border border-gray-200 rounded-lg">
                <Icon name="DollarSign" size={24} className="mx-auto text-gray-400 mb-2" />
                <div className="text-sm font-medium text-gray-600">Cash Flow</div>
              </div>
              <div className="p-3 border border-gray-200 rounded-lg">
                <Icon name="Scale" size={24} className="mx-auto text-gray-400 mb-2" />
                <div className="text-sm font-medium text-gray-600">Trial Balance</div>
              </div>
            </div>
            <div className="mt-6">
              <span className="inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium bg-blue-100 text-blue-800">
                <Icon name="Clock" size={16} className="mr-2" />
                Coming Soon
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsTab;